"use strict";
(self["webpackChunkporta"] = self["webpackChunkporta"] || []).push([[6651],{

/***/ 49506
() {




/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(49506));
/******/ }
]);